import React from 'react'
import { HorizontalStack, Link } from '@ztechapps/webui.util'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { useDeleteTemplate, useUser } from '@ztechapps/common.hook'
import { humanize } from '@ztechapps/common.utils'

export const ListRow = (props: BodyRowConfig) => {
  const { _id, name, description, category, onSelect } = props

  return (
    <>
      <RowNumberBodyCell {...props} />
      {props._renderDataBodyCell({
        name: (
          <div>
            <div className="fw-bold">
              <Link
                onClick={async () => {
                  await onSelect({ _id, name, description, category })
                }}
              >
                {name}
              </Link>
            </div>
          </div>
        ),
        category: humanize(category),
      })}

      <td>
        <HorizontalStack gap={2}>
          <FavoriteTemplate {...props} />
          <DeleteTemplate {...props} />
        </HorizontalStack>
      </td>
    </>
  )
}

export const FavoriteTemplate = (props: BodyRowConfig) => {
  const { addFavorite, isInFavorites, _id } = props
  const isFavorite = React.useMemo(() => isInFavorites({ templateId: _id }), [_id, isInFavorites])
  const onClick = () => {
    return addFavorite({ templateId: _id })
  }

  return (
    <BusyButtonLink
      icon="heart"
      className={isFavorite ? 'text-danger' : 'text-muted'}
      title={isFavorite ? 'remove to favorites' : 'add to favorites'}
      onClick={onClick}
    />
  )
}

export const DeleteTemplate = (props: BodyRowConfig) => {
  const { _id, scope } = props
  const { isSuperAdmin } = useUser()
  const { onDelete } = useDeleteTemplate()
  const onClick = () => onDelete(_id)

  // An app-scope template is written only by a superAdmin.
  const isBlocked = scope?.key === 'app' && !isSuperAdmin

  return (
    <BusyButtonLink
      icon="trash"
      title="Delete template"
      disabledReason={isBlocked ? 'Only a super admin can delete an app-scope template' : undefined}
      onClick={onClick}
      bsStyle="danger"
      className="text-danger"
    />
  )
}
